import Vue from 'vue'
import VueI18n from 'vue-i18n'
import projMsgZhCn from '@/config/lang/zh-CN'

export function getLang() {
	return localStorage.getItem(process.env.VUE_APP_TITLE + "_lang")
}

export function setLang(lang) {
	localStorage.setItem(process.env.VUE_APP_TITLE + "_lang", lang)
}

export default function(options) {
	var { store, router } = options

	Vue.use(VueI18n)

	// 浏览器语言 -> localStorage语种 -> zh-CN
	const navLang = navigator.language
	// 缓存语言选项
	const lsLang = getLang()

	// 现只支持zh-CN
	// let lang = lsLang || navLang || 'zh-CN'
	let lang = 'zh-CN'

	Vue.config.lang = lang

	// vue-i18n 6.x+写法
	Vue.locale = () => {}

	// 记忆用户的语言选择
	store.subscribe((mutation, state) => {
		if (mutation.type == "setLocal") {
			setLang(state.app.local)
		}
	})

	// expose
	return Vue.$i18n = new VueI18n({
		locale: lang,
		messages: {
			'zh-CN': projMsgZhCn,
		}
	})
}